<template>
  <div class="layout-detail">
    <topBar></topBar>
    <div class="body">
      <div class="head main">
        <div class="head-top">
          <router-link tag="div" to="/" class="logo-img">
            <img src="../assets/imgs/logo.png" width="200" />
          </router-link>
          <div class="search-box">
            <!-- <input class="search-input" placeholder="请输入商品名称/商品链接" />
            <span class="search-btn"><i class="iconfont icon-search mr10 "></i>搜索</span>-->
            <a-input-search style="width: 400px;" v-model="key" @search="onSearch" size="large">
              <span slot="enterButton">
                <img src="../assets/search.png" width="19px" />
                搜索
              </span>
            </a-input-search>
            <button class="ml20 my-car" @click="goCart">
              <img src="../assets/cart.png" width="23px" />
              我的购物车
            </button>
          </div>
        </div>
        <div class="head-bottom">
          <ul>
            <li class="font14 mr30 head-bottom-li">
              <router-link tag="span" to="/">首页</router-link>
            </li>
            <li class="font14 mr30 head-bottom-li" v-for="(item, index) in liList" :key="index">
              <router-link tag="span" :to="`/productList?ageStage=${item.ageStage}&value=${item.value}`">{{
                item.name
              }}</router-link>
            </li>
            <!-- <li class="font14 mr30 head-bottom-li">
              <router-link tag="span" to>关于我们</router-link>
            </li>
            <li class="font14 mr30 head-bottom-li">
              <router-link tag="span" to>联系我们</router-link>
            </li>-->
          </ul>
          <div class="categroy">
            <div class="categroy-all"><i class="iconfont icon-m-weixinwenzhang mr10"></i>全部商品类型</div>
            <ul class="category-ul" @mouseleave="noneSecond">
              <li @mouseover="getSecond(item.id)" v-for="(item, index) in categroyList" :key="index">
                <router-link class="span-click" tag="span" :to="`/productList/${item.id}`">{{ item.name }}</router-link>
              </li>
              <div class="second-category" ref="second" @mouseleave="noneSecond">
                <ul>
                  <router-link tag="li" :to="`/productList/${item.id}`" v-for="(item, index) in secondCategory" :key="index">{{
                    item.name
                  }}</router-link>
                </ul>
              </div>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <router-view></router-view>
    <foot-bar></foot-bar>
  </div>
</template>
<script>
import topBar from './sideBar/topBar'
import footBar from './sideBar/footBar'
import { getCategory } from '@/serve/category'
import { mapMutations } from 'vuex'
export default {
  name: 'layoutDetail',
  components: {
    topBar,
    footBar
  },
  data () {
    return {
      liList: [
        { name: '海富园', value: '', ageStage: '' },
        { name: '精英园', value: '', ageStage: '' },
        { name: '中小学', value: '', ageStage: '' }
      ],
      categroyList: [], // 一级分类
      secondCategory: [], // 二级分类
      key: ''
    }
  },
  methods: {
    ...mapMutations(['SET_KEYWORD']),
    onSearch (keyWord) {
      this.SET_KEYWORD(keyWord)
      this.$router.push({ path: '/productList', query: { keyWord: keyWord } })
    },
    goCart () {
      this.$router.push({ path: '/shoppingCart' })
    },
    // 获取二级分类
    getSecond (id) {
      getCategory({ idParent: id }).then(res => {
        this.secondCategory = res
        if (res.length > 0) {
          this.$refs.second.style.display = 'block'
        } else {
          this.$refs.second.style.display = 'none'
        }
      })
    },
    noneSecond () {
      this.$refs.second.style.display = 'none'
    },
    // 获取一级分类
    getCategory () {
      getCategory({ idParent: '0' }).then(res => {
        this.categroyList = res
        let index = this.categroyList.findIndex(item => item.id === '6')
        this.categroyList.unshift(...this.categroyList.splice(index, 1))
        if (this.$route.query.keyWord) {
          this.key = this.$route.query.keyWord
        }
      })
    }
  },
  created () {
    this.getCategory() // 获取分类信息
    let blocTagBlocId = window.sessionStorage.getItem('blocTagBlocId')
    let ageStage = window.sessionStorage.getItem('ageStage')
    if (blocTagBlocId === 'adminid') {
      this.liList[0].value = blocTagBlocId
      this.liList[1].value = 'no'
      this.liList[2].value = 'no'
    } else if (blocTagBlocId === 'jyy') {
      this.liList[1].value = blocTagBlocId
      this.liList[0].value = 'no'
      this.liList[2].value = 'no'
    } else if (blocTagBlocId === 'other') {
      this.liList[1].value = 'no'
      this.liList[0].value = 'no'
      this.liList[2].value = 'no'
    }else if (ageStage) {
      this.liList[0].value = 'no'
      this.liList[1].value = 'no'
      this.liList[2].ageStage = ageStage
    } else if (!ageStage && !blocTagBlocId) {
      this.liList[0].value = 'adminid'
      this.liList[1].value = 'jyy'
      this.liList[2].ageStage = 'PS,JS,HS'
    }
  }
}
</script>
<style lang="less">
.ant-input-search-enter-button .ant-input-group-addon .ant-input-search-button {
  font-size: 14px;
  font-weight: 700;
  background: #f88f6f;
}
</style>
<style lang="less" scoped>
.layout-detail {
  .body {
    box-shadow: 0px 1px 6px #ccc;
  }
  .head {
    padding: 20px 0 1px 0;
    /* width: 1190px;
    margin: 0 auto; */

    .head-top {
      display: flex;
      justify-content: space-between;

      .logo-img {
        cursor: pointer;
      }

      .search-box {
        .search-input {
          height: 40px;
          width: 300px;
          border: 1px solid #f88f6f;
          padding-left: 10px;
          outline: none;
        }
        .search-btn {
          display: inline-block;
          line-height: 40px;
          width: 80px;
          text-align: center;
          color: #fff;
          background: #f88f6f;
          vertical-align: bottom;
          font-size: 16px;
          font-weight: 700;
          cursor: pointer;
        }
        .my-car {
          height: 40px;
          border: none;
          color: #fff;
          font-size: 14px;
          font-weight: 700;
          background: #7ccb9b;
          padding: 0 20px;
          cursor: pointer;
        }
      }
    }
    .head-bottom {
      margin-top: 50px;
      margin-left: 300px;
      position: relative;
      .head-bottom-li {
        display: inline;
        cursor: pointer;
        &:hover {
          color: #e69b47;
        }
      }

      .categroy {
        z-index: 99;
        position: absolute;
        top: -11px;
        left: -300px;
        width: 280px;
        box-shadow: 2px 1px 8px #ccc;
        background: #fff;

        .second-category {
          display: none;
          position: absolute;
          box-shadow: 2px 1px 8px #ccc;
          left: 280px;
          top: 45px;
          background: #fff;
          width: 220px;
          height: 492px;
          li {
            padding: 10px 20px;
          }
        }
        ul {
          padding: 0;
        }

        .categroy-all {
          background: #e69b47;
          color: #fff;
          padding: 10px 20px;
          font-weight: 700;
          font-size: 16px;
          cursor: pointer;
          &:hover + .category-ul {
            height: 491px;
          }
        }

        .category-ul {
          height: 0px;
          overflow: hidden;
          margin-bottom: 0;
          padding: 0;
          transition: all 0.5s;

          &:hover {
            height: 491px;
          }
        }

        li {
          // padding: 10px 20px;
          cursor: pointer;
          &:hover {
            background: rgba(0, 0, 0, 0.08);
            color: #e69b47;
          }
          .span-click {
            display: block;
            padding: 10px 20px;
          }
        }
      }
    }
  }
}
</style>
